import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-large-top, chev top, up"><path fillRule="evenodd" clipRule="evenodd" d="M12.1279 9.69918C12.0491 9.65236 11.9511 9.65236 11.8723 9.69918L3.13342 14.8953C2.77739 15.107 2.31716 14.99 2.10546 14.634C1.89377 14.2779 2.01078 13.8177 2.36681 13.606L11.1057 8.40987C11.6569 8.08213 12.3433 8.08213 12.8945 8.40987L21.6334 13.606C21.9895 13.8177 22.1065 14.2779 21.8948 14.634C21.6831 14.99 21.2228 15.107 20.8668 14.8953L12.1279 9.69918Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLargeTop;
